export default __webpack_public_path__ + "static/media/modely1.3e2e62c3.jfif";